import { useRoutes } from 'hookrouter';
import React, { useEffect } from 'react';

import { useFaroEnabled } from './hooks/useFaroEnabled';
import { initFaro } from './observability';
import { NotFoundPage } from './pages/NotFound';
import { routes } from './routes';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function App(props: { basePath: string }) {
  const routeResult = useRoutes(routes);
  const { faroEnabled } = useFaroEnabled();

  // Grafana Faro is gated behind the ENABLE_GRAFANA_FARO feature flag
  useEffect(() => {
    if (faroEnabled) {
      initFaro();
    }
  }, [faroEnabled]);

  return routeResult ? <React.StrictMode>{routeResult}</React.StrictMode> : <NotFoundPage />;
}

export default App;
